export default __webpack_public_path__ + "static/media/login-bg1.4bac0985.jpg";